<label class="btn btn-info btn-file" v-on:change="changeHandler"><i class="fa fa-upload"></i><input type="file" multiple>
Upload</label>